!(function (v) {
    "use strict";
    jQuery.fn.beforeAfter = function (e) {
        var f = jQuery.extend({ movable: !0, clickMove: !0, alwaysShow: !0, position: 50, opacity: 0.4, activeOpacity: 1, hoverOpacity: 0.8, separatorColor: "#ffffff", bulletColor: "#ffffff", arrowColor: "#333333" }, e);
        return this.each(function () {
            var n, e, o, t, r, i, s, c, u, d, a, l, h, y, p;
            (n = this),
                2 == jQuery(n).children().length
                    ? ((e = v(n).children()[0]),
                      (o = v(n).children()[1]),
                      (l = v(n).css("position")),
                      v(n).css("z-index"),
                      (t = v(n).css("overflow")),
                      (s =
                          "position:" +
                          v(e).css("position") +
                          ";top:" +
                          v(e).css("top") +
                          ";left:" +
                          v(e).css("left") +
                          ";width:" +
                          v(e).css("width") +
                          ";height:" +
                          v(e).css("height") +
                          ";z-index:" +
                          (u = v(e).css("z-Index")) +
                          ";float:" +
                          v(e).css("float")),
                      (c = "position:" + v(o).css("position") + ";top:" + v(o).css("top") + ";left:" + v(o).css("left") + ";width:" + v(o).css("width") + ";height:" + v(o).css("height") + ";z-index:" + v(o).css("z-Index")),
                      jQuery(n).attr("data-bareservedstyle", "position:" + l + ";overflow:" + t),
                      jQuery(e).attr("data-bareservedstyle", s),
                      jQuery(o).attr("data-bareservedstyle", c),
                      (l = isNaN(parseInt(u)) ? 0 : parseInt(u)),
                      (t = "-webkit-user-select:none;-ms-user-select:none;user-select:none;"),
                      jQuery(n).css({ position: "relative", overflow: "hidden" }),
                      jQuery(e).css({ position: "relative", top: "0", left: "0", width: "100%" }),
                      jQuery(o).css({ position: "absolute", top: "0", right: "0", width: "auto", height: "100%", "z-index": l + 1 }),
                      (r = document.createElement("DIV")).setAttribute("style", "position:relative;width:100%;height:100% ;" + t),
                      jQuery(e).clone({ withDataAndEvents: !0 }).appendTo(r),
                      (i = document.createElement("DIV")).setAttribute("style", "position:absolute;width:" + f.position + "%;height:100%;top:0px;right:0px;overflow:hidden;" + t),
                      jQuery(o).clone({ withDataAndEvents: !0 }).appendTo(i),
                      (s = document.createElement("I")).setAttribute("style", "border:solid black;border-width:0 2px 2px 0;display:inline-block;padding:3px;transform:rotate(135deg);-webkit-transform:rotate(135deg);"),
                      (c = document.createElement("I")).setAttribute("style", "border:solid black;border-width:2px 0 0 2px;display:inline-block;padding:3px;transform:rotate(135deg);-webkit-transform:rotate(135deg);"),
                      (u = document.createElement("DIV")).setAttribute(
                          "style",
                          "position:absolute;width:32px;height:32px;line-height:30px;padding:4xp;text-align:center;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:50%;background-color:#fff;"
                      ),
                      (d = document.createElement("DIV")).setAttribute("style", "position:relative;width:100%;height:100%;"),
                      (a = document.createElement("DIV")).setAttribute(
                          "style",
                          "position:absolute;width:2px;height:100%;top:0px;right:" + f.position + "%;overflow:visible;transform:translateX(50%);background-color: #fff;cursor:e-resize;opacity:" + f.opacity + ";z-index:" + l + "2;" + t
                      ),
                      jQuery(s).css("border-color", f.arrowColor),
                      jQuery(c).css("border-color", f.arrowColor),
                      jQuery(u).css("background-color", f.bulletColor),
                      jQuery(a).css("background-color", f.separatorColor),
                      u.append(s),
                      u.append(c),
                      d.append(u),
                      a.append(d),
                      n.append(r),
                      n.append(i),
                      n.append(a),
                      jQuery(e).remove(),
                      jQuery(o).remove(),
                      (l = function () {
                          0 < jQuery(r).children().width() && jQuery(i).children().width(jQuery(r).children().width()), 0 < jQuery(r).children().height() && jQuery(i).children().height(jQuery(r).children().height());
                      }),
                      jQuery(window).on("resize", l),
                      f.movable &&
                          ((h = !1),
                          f.clickMove &&
                              (jQuery(r).on("click", function () {
                                  void 0 !== f.onMoveStart && f.onMoveStart();
                                  var e = jQuery(n).width(),
                                      o = jQuery(a).css("right"),
                                      e = (((parseInt(o) + Math.min(0.05 * e, 5)) / e) * 100).toFixed(2),
                                      e = 100 < e ? 100 : e < 0 ? 0 : e;
                                  (e += "%"), jQuery(i).width(e), jQuery(a).css("right", e), void 0 !== f.onMoving && o != jQuery(a).css("right") && f.onMoving(), void 0 !== f.onMoveEnd && f.onMoveEnd();
                              }),
                              jQuery(i).on("click", function () {
                                  void 0 !== f.onMoveStart && f.onMoveStart();
                                  var e = jQuery(n).width(),
                                      o = jQuery(a).css("right"),
                                      e = (((parseInt(o) - Math.min(0.05 * e, 5)) / e) * 100).toFixed(2),
                                      e = 100 < e ? 100 : e < 0 ? 0 : e;
                                  (e += "%"), jQuery(i).width(e), jQuery(a).css("right", e), void 0 !== f.onMoving && o != jQuery(a).css("right") && f.onMoving(), void 0 !== f.onMoveEnd && f.onMoveEnd();
                              })),
                          jQuery(n).on("mouseenter", function () {
                              jQuery(a).css("opacity", f.hoverOpacity);
                          }),
                          jQuery(n).on("mouseleave", function () {
                              jQuery(a).css("opacity", f.opacity);
                          }),
                          (y = function (e) {
                              var e = e.pageX || e.touches[0].clientX,
                                  o = jQuery(n).offset().left,
                                  t = jQuery(n).width(),
                                  r = jQuery(a).css("right"),
                                  o = (((o + t - e) / t) * 100).toFixed(2),
                                  e = 100 < o ? 100 : o < 0 ? 0 : o;
                              (e += "%"), jQuery(i).width(e), jQuery(a).css("right", e), void 0 !== f.onMoving && r != jQuery(a).css("right") && f.onMoving();
                          }),
                          (p = function (e) {
                              (h = !0), jQuery(a).css("opacity", f.opacity), void 0 !== f.onMoveEnd && f.onMoveEnd();
                          }),
                          jQuery(a).on("mousedown", function (e) {
                              (h = !1),
                                  jQuery(a).css("opacity", f.activeOpacity),
                                  void 0 !== f.onMoveStart && f.onMoveStart(),
                                  jQuery(document).on("mousemove", y),
                                  jQuery(document).on("mouseup", function (e) {
                                      jQuery(document).off("mousemove", y), h || p();
                                  }),
                                  jQuery(window).on("mouseup", function (e) {
                                      jQuery(document).off("mousemove", y), h || p();
                                  });
                          }),
                          jQuery(a).on("touchstart", function (e) {
                              (h = !1),
                                  void 0 !== f.onMoveStart && f.onMoveStart(),
                                  jQuery(a).css("opacity", f.activeOpacity),
                                  jQuery(document).on("touchmove", y),
                                  jQuery(document).on("touchcancel", function (e) {
                                      jQuery(document).off("touchmove", y), h || p();
                                  }),
                                  jQuery(window).on("touchcancel", function (e) {
                                      jQuery(document).off("touchmove", y), h || p();
                                  }),
                                  jQuery(document).on("touchend", function (e) {
                                      jQuery(document).off("touchmove", y), h || p();
                                  });
                          })),
                      l())
                    : console.log("%cWarning: %s", "color:#e4672e;font-size:200%;", "BeforeAfter plugin need absolutely two childrens.");
        });
    };
})(jQuery);
const sliderOptions = { slidesPerView: 1, loop: !0, effect: "fade", fadeEffect: { crossFade: !0 }, allowTouchMove: !1 };
handleSliders(".js-slider", sliderOptions),
    $(function () {
        $(window).on("load", function () {
            $(".js-before-after").beforeAfter({ opacity: 1, hoverOpacity: 1 });
          /*setTimeout(() => {
            $(".js-before-after").each(function()
            {
                let beforeAfter = $(this);
                let before = beforeAfter.children("div:first-child");
                let after = beforeAfter.children("div:nth-child(2)");
                before.prepend('<div class="slider__badges-entry before"><p>BEFORE</p></div>');
                after.prepend('<div class="slider__badges-entry after"><p>AFTER</p></div>');
            });
          }, 1500);*/
        });
    });
